import './alteration-detail-image-popup.scss'

import { defineComponent, PropType } from 'vue';
import { BModal } from "bootstrap-vue";

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { DeleteImageClickEvent, MediaArea } from "@skinsoft/entity-ui";
import { DELETE_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC, MEDIA_END_LOADING_TOPIC, MEDIA_ID_CHANGED_FROM_CACHE, PRINCIPAL_IMAGE_CLICK_TOPIC } from "@skinsoft/bus";
import { DETAILED_ALTERATION_IMAGE_ADDED } from '../../../../events';

export const AlterationDetailImagePopup = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMediaArea: MediaArea
    },
    props: {
        mediaIds: {
            type: Array as PropType<String[]>,
            default: [],
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "alterationDetailImagePopup.title",
        },
    },
    template: require('./alteration-detail-image-popup.html'),
    data() {
        return {
            clickOnMediasAllowed: true,
            mediaUploadInProgress: false,
            mediaAreasId: '',

            DELETE_IMAGE_CLICK_TOPIC: DELETE_IMAGE_CLICK_TOPIC,
            IMAGE_UPLOADED_TOPIC: IMAGE_UPLOADED_TOPIC,
            PRINCIPAL_IMAGE_CLICK_TOPIC: PRINCIPAL_IMAGE_CLICK_TOPIC,
            MEDIA_ID_CHANGED_FROM_CACHE: MEDIA_ID_CHANGED_FROM_CACHE,
            IMAGE_CLICK_TOPIC: IMAGE_CLICK_TOPIC,
        }
    },
    mounted() {
        this.mediaAreasId = window.performance.now().toString() + Math.random().toString(16).slice(2)
        this.subscribeToBus(MEDIA_END_LOADING_TOPIC, (message => {
            this.clickOnMediasAllowed = true
        }))
    },
    computed: {
        computedTitle(): string {
            return this.$t(this.title as string) as string ?? this.title as string
        },
    },
    methods: {
        onImageUploaded(fileData) {
            // we upload media only in cache,

            this.clickOnMediasAllowed = false
            const formData = new FormData()
            formData.append("file", fileData.file)

            this.mediaUploadInProgress = true
            // Retrieving temp id and uploading the media on backend asynchronously
            const cacheKey = (this as any).$imageTransferHelper.uploadImageInCache(fileData.file, fileData.url)
            setTimeout(() => { // if no timeout, the DOM may not have the time to update
                this.mediaUploadInProgress = false
            }, 500)

            this.$emit(DETAILED_ALTERATION_IMAGE_ADDED, { cacheKey: cacheKey })
            this.clickOnMediasAllowed = true
        },

        ondeleteImageClicked(event: DeleteImageClickEvent) {
            if(event.imageId) {
                this.$emit(DELETE_IMAGE_CLICK_TOPIC, event)
            } else {
                if(this.mediaIds.length && this.mediaIds.length >= event.imageListIndex) {
                    this.$emit(
                        DELETE_IMAGE_CLICK_TOPIC,
                        {
                            imageListIndex: event.imageListIndex,
                            imageId: this.mediaIds[event.imageListIndex] as string,
                        } as DeleteImageClickEvent
                    )
                }
            }
        },

        onImageClicked() {
            // nothing yet
        },

        closeModal() {
            (this.$refs.modal as InstanceType<typeof BModal>).hide()
        },

        openModal() {
            (this.$refs.modal as InstanceType<typeof BModal>).show()
        },
    },
})
